module.exports = __webpack_public_path__ + "img/cameramanager-logo.a72b2bb4.png";